export function smallCaseStudySlider() {
    let slider = $(".small-case-study-slider");
    slider.slick({
        arrows: false,
        dots: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/smallCaseStudySlider.js